import { FormGroup } from "@angular/forms";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ModalOptions } from "..";

export function displayModalComponent(component: any, size: string, options: ModalOptions, modalService: NgbModal, params: any[]): NgbModalRef {
  const windowref = modalService.open(component, { size: size, backdrop: 'static', windowClass: options.windowClass, keyboard: true, scrollable: options.scrollable ?? false });

  if (options.required) {
    windowref.componentInstance.options = options;

    if (params) {
      windowref.componentInstance.params = params;
    }
  }
  return windowref;
}

export function displayModalEditorComponent(component: any, size: string, options: ModalOptions, modalService: NgbModal, form: FormGroup): NgbModalRef {
  const windowref = modalService.open(component, { size: size, backdrop: 'static', windowClass: options.windowClass, keyboard: true, scrollable: options.scrollable ?? false });
  windowref.componentInstance.options = options;
  if (form) {
    windowref.componentInstance.form = form;
  }
  return windowref;
}


